export default __webpack_public_path__ + "static/media/head11.ae573242.svg";